import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { bookieAPI, clubAPI } from '../services/api';
import './LinkBookie.css';

function LinkBookie() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [bookieData, setBookieData] = useState(null);

  // Listen for postMessage from bookie iframe on completion
  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.data?.type === 'BOOKIE_ONBOARDING_COMPLETE') {
        const clubId = searchParams.get('clubId');
        try {
          await clubAPI.bookieCallback({
            clubId,
            status: event.data.status,
            bookieCustomerId: event.data.clientId,
            bookieUsername: event.data.username,
          });
        } catch (err) {
          console.error('Bookie callback failed:', err);
        }
        navigate('/dashboard');
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [searchParams, navigate]);

  useEffect(() => {
    const loadBookieLink = async () => {
      try {
        const clubId = searchParams.get('clubId');
        const action = searchParams.get('action'); // 'new' or 'existing'

        if (!clubId) {
          setError('Club ID is required');
          setLoading(false);
          return;
        }

        // Get the registration URL from the backend
        const data = await bookieAPI.getRegistrationLink(clubId, action);

        if (!data.success) {
          setError(data.error || 'Failed to get registration link');
          setLoading(false);
          return;
        }

        setBookieData(data);
        setLoading(false);
      } catch (err) {
        console.error('Error loading bookie link:', err);
        setError(err.response?.data?.error || 'Failed to load bookie registration');
        setLoading(false);
      }
    };

    loadBookieLink();
  }, [searchParams]);

  if (loading) {
    return (
      <div className="link-bookie-wrapper">
        <div className="link-bookie-container">
          <div className="loading-spinner"></div>
          <p>Loading bookie registration...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="link-bookie-wrapper">
        <div className="link-bookie-container">
          <div className="error-message">
            <h2>Error</h2>
            <p>{error}</p>
            <button onClick={() => navigate('/dashboard')} className="btn-primary">
              Return to Dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="link-bookie-wrapper">
      <div className="link-bookie-container">
        <div className="link-bookie-header">
          <h1>{bookieData.isNew ? 'Create Your AnyBookie Account' : 'Link Your AnyBookie Account'}</h1>
          <p className="subtitle">
            {bookieData.isNew
              ? 'Complete the form below to create your betting account'
              : 'Log in to link your existing account to this club'}
          </p>
        </div>

        <div className="bookie-iframe-container">
          <iframe
            src={bookieData.url}
            title={`${bookieData.brokerName} Registration`}
            className="bookie-iframe"
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation"
          />
        </div>

        <div className="link-bookie-footer">
          <p className="info-text">
            Complete the registration process in the frame above.
            You'll be automatically redirected when complete.
          </p>
        </div>
      </div>
    </div>
  );
}

export default LinkBookie;
